<div *ngIf ="title !='Events'" class="card margin-b">
    <div class="card-body color border-r">
        <div class="display">
            <div class="image-wrapper">
                <img src="assets/church_image.jpg" style="display: none;">
            </div>
            <div class="text-area">
                <div>
                    <h5 class="card-title">
                        <app-skelton></app-skelton>
                    </h5>
                </div>
                <div class="time-text display">
                    <span>
                        <p>
                            <app-skelton></app-skelton>
                        </p>
                    </span>

                </div>

            </div>

        </div>


        <p class="card-text"></p>

    </div>
</div>


<div *ngIf ="title == 'Events'" class="card margin-b">
    <div class="image-wrapper" style="height: 140px;border-radius: 0px; width:100%">
        <img class="card-img-top" src="assets/church_image.jpg" style="display: none;" alt="">
    </div>





    <div class="card-body">
        <h5 class="card-title margin-b">
            <app-skelton></app-skelton>
        </h5>

        <div class="detail-text">

            <div class="margin-l text-wrap" >
                <app-skelton></app-skelton>
            </div>
        </div>

        <div class="detail-text">
            <div class="margin-l text-wrap" >
                <app-skelton></app-skelton>
            </div>
        </div>
        <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's
                content.</p> -->
    </div>

</div>